import { render, staticRenderFns } from "./PrivacyUnitShift.vue?vue&type=template&id=a98a939a&scoped=true"
import script from "./PrivacyUnitShift.vue?vue&type=script&lang=js"
export * from "./PrivacyUnitShift.vue?vue&type=script&lang=js"
import style0 from "./PrivacyUnitShift.vue?vue&type=style&index=0&id=a98a939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98a939a",
  null
  
)

export default component.exports